import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { SharedModule } from '../../shared/shared.module';
import { NotificationsListComponent } from './components/notifications-list/notifications-list.component';
import { NotificationsCreateComponent } from './components/notifications-create/notifications-create.component';

@NgModule({
  declarations: [
    NotificationsListComponent,
    NotificationsCreateComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    SharedModule
  ]
})
export class NotificationsModule { }
